import Dropdown from '@jetbrains/ring-ui/components/dropdown/dropdown'
import type {ListDataItem} from '@jetbrains/ring-ui/components/list/consts'
import type {PopupAttrs} from '@jetbrains/ring-ui/components/popup/popup'
import classNames from 'classnames'
import * as React from 'react'
import type {SyntheticEvent} from 'react'

import IconButton from '../IconButton/IconButton'
import PopupMenu from '../Popup/PopupMenu'

import styles from './ArrowPopupMenu.css'

class ArrowPopupMenu extends React.PureComponent<{
  className?: string
  anchorClassName?: string
  icon?: string
  title?: string
  elements: ReadonlyArray<ListDataItem> | null | undefined
  directions?: PopupAttrs['directions']
}> {
  onClick: (event: SyntheticEvent) => void = event => {
    event.stopPropagation()
    event.preventDefault()
  }

  render(): React.ReactNode {
    const {className, anchorClassName, title = '', elements, icon, directions} = this.props
    const classes = classNames(styles.arrowPopupMenu, className)
    const anchor = (
      <IconButton
        className={classNames(styles.anchor, anchorClassName)}
        title={title}
        aria-label={title || 'Actions'}
        icon={icon != null ? icon : 'more-options'}
      />
    )

    if (elements == null || elements.length === 0) {
      return null
    }

    return (
      // onClick only used for preventDefault & stopPropagation
      <span role="presentation" className={classes} onClick={this.onClick}>
        <Dropdown anchor={anchor} hoverMode>
          <PopupMenu data={elements} closeOnSelect directions={directions} />
        </Dropdown>
      </span>
    )
  }
}

export default ArrowPopupMenu
